import { render, staticRenderFns } from "./SixmwtDashboard.vue?vue&type=template&id=06d0eb3e&scoped=true"
import script from "./SixmwtDashboard.vue?vue&type=script&lang=js"
export * from "./SixmwtDashboard.vue?vue&type=script&lang=js"
import style0 from "./SixmwtDashboard.vue?vue&type=style&index=0&id=06d0eb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0eb3e",
  null
  
)

export default component.exports